import { CompanyPolicyVersionHistoryModel } from './companyPolicyVersionHistoryModel';

export class CompanyPolicyVersionHistoryViewModel extends CompanyPolicyVersionHistoryModel {
    public createdDate: Date;
}
